import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import CategoryManager from './CategoryManager';
import randomInt from "../utils/randomInt";
import ProductFocuses from "../routes/ProductFocuses";
import ProductFocusesManager from "./ProductFocusesManager";
import ActivityManager from "./ActivityManager";
import ProductFocusGroupContentManager from "./ProductFocusGroupContentManager";

class ProductFocusGroupsStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      id: null,
      name: null,
      cover: null,
      status: null,
      brandId: null,
      createdAt: null,
      updatedAt: null,
      createdBy: null,
      updatedBy: null,
      deletedAt: null,
      productFocusGroups: [],
      lastContentViewed: null,
    };
  }

  reduce(state, action) {
    switch (action.actionType) {

      case ActionTypes.PRODUCT_FOCUS_FETCH_BY_ID:
        ProductFocusesManager.fetchById(action.id);
        return this.getInitialState();

      case ActionTypes.PRODUCT_FOCUS_FETCH_BY_ID_COMPLETED:
        return action.productFocus;

      case ActionTypes.PRODUCT_FOCUS_GROUP_CONTENT_VIEWED:
        ProductFocusGroupContentManager.saveActivity({
          parent_id: action.groupId,
          entity_id: action.id,
          event_type: 'product_focus_group_content_viewed'
        });
        return state;

      case ActionTypes.PRODUCT_FOCUS_GROUP_CONTENT_VIEWED_COMPLETED:
        return action.productFocus

      default:
        return state;
    }
  }

}

export default new ProductFocusGroupsStore();
